import SolutionDeviceDeployment from './SolutionDeviceDeployment';
import SolutionDeviceDeploymentTitle from './components/SolutionDeviceDeploymentTitle';

export { SolutionDeviceDeploymentTitle };
export default SolutionDeviceDeployment;
